/**
 * Core vendor bundle — loaded on every page via layout.pug.
 *
 * Exposes globals so existing vanilla JS code continues to work unchanged:
 *   window.jQuery, window.$, window.moment, window.jwt_decode
 */

// --- CSS (produces core.bundle.css as a sibling) ---
require('@fortawesome/fontawesome-free/css/all.css');
// Bootstrap 3 CSS loaded via CDN in layout.pug
require('datatables.net-bs/css/dataTables.bootstrap.css');
require('datatables.net-buttons-bs/css/buttons.bootstrap.css');
require('datatables.net-fixedcolumns-bs/css/fixedColumns.bootstrap.css');
require('datatables.net-fixedheader-bs/css/fixedHeader.bootstrap.css');
// bootstrap-multiselect CSS loaded via CDN in layout.pug
// require('bootstrap-multiselect/dist/css/bootstrap-multiselect.css');

// --- JS ---
// jQuery — must be first; everything else depends on it
var jQuery = require('jquery');
window.jQuery = window.$ = jQuery;

// Bootstrap 3 JS loaded via CDN in layout.pug

// DataTables core + plugins
require('datatables.net-bs')(window, jQuery);
window.JSZip = require('jszip');
require('datatables.net-buttons-bs')(window, jQuery);
require('datatables.net-buttons/js/buttons.html5.js')(window, jQuery);
require('datatables.net-fixedcolumns-bs')(window, jQuery);
require('datatables.net-fixedheader-bs')(window, jQuery);

// Moment.js
var moment = require('moment');
window.moment = moment;

// DataTables moment sorting plugin (inline — not available as a standalone npm package)
// Source: https://cdn.datatables.net/plug-ins/1.11.5/sorting/datetime-moment.js
(function ($, moment) {
  function strip(d) {
    if (typeof d === 'string') {
      d = d.replace(/(<.*?>)|(\r?\n|\r)/g, '');
      d = d.trim();
    }
    return d;
  }
  $.fn.dataTable.moment = function (format, locale, reverseEmpties) {
    var types = $.fn.dataTable.ext.type;
    types.detect.unshift(function (d) {
      d = strip(d);
      if (d === '' || d === null) return 'moment-' + format;
      return moment(d, format, locale, true).isValid() ? 'moment-' + format : null;
    });
    types.order['moment-' + format + '-pre'] = function (d) {
      d = strip(d);
      return !moment(d, format, locale, true).isValid()
        ? (reverseEmpties ? -Infinity : Infinity)
        : parseInt(moment(d, format, locale, true).format('x'), 10);
    };
  };
})(jQuery, moment);

// JWT Decode
var jwt_decode = require('jwt-decode');
window.jwt_decode = jwt_decode;

// Bootstrap Multiselect — loaded via CDN in layout.pug (esbuild UMD wrapper breaks it)
// require('bootstrap-multiselect');

// Fluent UI Web Components
require('@fluentui/web-components');
